import type { TrackingLabels } from "./TrackingLabels";

export function updateLegacyLabel<T extends keyof TrackingLabels>(
  elem: HTMLElement,
  label: T,
  value?: TrackingLabels[T],
) {
  const { tsLabels = "{}" } = elem.dataset;
  const tsLabelData = JSON.parse(tsLabels);
  if (value) {
    tsLabelData[label] = value;
  } else if (Object.prototype.hasOwnProperty.call(tsLabelData, label)) {
    delete tsLabelData[label];
  }
  setLegacyLabels(elem, tsLabelData);
}

export function setLegacyLabels(elem: HTMLElement, labels: Partial<string>) {
  elem.dataset.tsLabels = JSON.stringify(labels);
}
